module.exports = __webpack_public_path__ + "img/location.8997924e.svg";